import React, {useState} from 'react'
import { Panel } from 'rsuite';
import DrawerView from '../pages/tables/members/DrawerView';
import {
    Drawer,
    DrawerProps,
    Button,
    Form,
    Stack,
    InputNumber,
    InputGroup,
    Slider,
    Rate,
    SelectPicker,
    Input,
    
  } from 'rsuite';
  import SearchIcon from '@rsuite/icons/Search';

const BuyerC = (props: DrawerProps) => {
    const [showDrawer, setShowDrawer] = useState(false);
    const { onClose, ...rest } = props;

    const ratingList = Array.from({ length: 5 }).map((_, index) => {
        return {
          value: index + 1,
          label: Array.from({ length: index + 1 })
            .map(() => '⭐️')
            .join('')
        };
      });
      const [rating, setRating] = useState<number | null>(null);
      const [searchKeyword, setSearchKeyword] = useState('');
    
  
  return (
    <>
    <div>
    <Stack className="table-toolbar buyer" justifyContent="space-between">
        <Button appearance="primary" onClick={() => setShowDrawer(true)}>
          Create Catalogue
        </Button>

        <Stack spacing={6}>
          <SelectPicker
            label="Rating"
            data={ratingList}
            searchable={false}
            value={rating}
            onChange={setRating}
          />
          <InputGroup inside>
            <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Title>Add a Product</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="primary">
            Confirm
          </Button>
          <Button onClick={onClose} appearance="subtle">
            Cancel
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form fluid>
          <Stack justifyContent="space-between" style={{ marginBottom: 20 }}>
            <Form.Group>
              <Form.ControlLabel>Catalogue Name</Form.ControlLabel>
              <Form.Control name="text" style={{ width: 485 }} />
            </Form.Group>
            {/* <Form.Group>
              <Form.ControlLabel>Last Name</Form.ControlLabel>
              <Form.Control name="lastname" style={{ width: 200 }} />
            </Form.Group> */}
          </Stack>
          <Form.Group>
            <Form.ControlLabel>Catalogue Type</Form.ControlLabel>
            <Form.Control name="text" type="text" />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>Material</Form.ControlLabel>
            <Form.Control name="city" />
          </Form.Group>
          <Form.Group>
            <Form.ControlLabel>Weight</Form.ControlLabel>
            <Form.Control name="street" />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>Rating</Form.ControlLabel>
            <Form.Control name="rating" accepter={Rate} />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>Skill Proficiency</Form.ControlLabel>
            <Form.Control name="skill" accepter={Slider} progress />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>Income</Form.ControlLabel>
            <InputGroup style={{ width: '100%' }}>
              <InputGroup.Addon>$</InputGroup.Addon>
              <Form.Control name="income" accepter={InputNumber} style={{ width: '100%' }} />
            </InputGroup>
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
    <DrawerView open={showDrawer} onClose={() => setShowDrawer(false)} />
    </div>
    <div  style={{ marginTop: 50, height: 50 }}>
    <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  <Panel shaded bordered bodyFill style={{ display: 'inline-block', width: 240 }}>
    <img src="https://via.placeholder.com/240x240" height="240" />
    <Panel header="RSUITE">
      <p>
        <small>
          A suite of React components, sensible UI design, and a friendly development experience.
        </small>
      </p>
    </Panel>
  </Panel>
  </div>
  
  </>
  )
}

export default BuyerC
